import type { TrafficIcon as TypeTrafficIcon } from '#types/enums';

import { TrafficIconComponent } from '../Icon/TrafficIcon';

import styles from './TrafficSectionItem.module.scss';

type Props = {
	icon?: TypeTrafficIcon | null;
	text?: string | null;
	timestamp?: string | null;
	title?: string | null;
};

export function TrafficSectionItem({ icon, text, timestamp, title }: Props) {
	return (
		<section className={`body3 ${styles.wrapper}`}>
			{!!icon && (
				<header className={styles.iconWrapper}>
					<TrafficIconComponent name={icon} />
				</header>
			)}

			<section className={styles.section}>
				{!!title && <h3 className={styles.title}>{title}</h3>}

				{!!text && <p>{text}</p>}
			</section>

			{!!timestamp && (
				<h3>
					<time dateTime={timestamp} className={styles.timestamp}>
						{timestamp}
					</time>
				</h3>
			)}
		</section>
	);
}
